import React from 'react';
import DvdBouncer from '../components/DvdBouncer';
import law_scales from '../assets/law_scales.svg';
import '../HeadPages.css';

export default function EmilyHome() {
  return (
    <div className="App-header" style={{ height: '100vh' }}>
      {/* DvdBouncer consumes 100% of its parent; App-header gives the dark bg */}
      <DvdBouncer imgSrc={law_scales} label="emilymabey.com" speed={120}/>
    </div>
  );
}
